import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import SelectSpecialization from "./SelectSpecialization";
import { Fragment } from "react";

function SpecializationContent() {

    const {
        setAllDoctorsFromBranch,
        selectedDoctorBySearch,
        setShowDoctorsModal,
        toSearchByDoctor,
    } = useConsultDoctorContext();


    const handleSearchDoctor=()=>{
        setShowDoctorsModal(true);

        //reset doctors list
        setAllDoctorsFromBranch([]);
    }

    let content = null;
    if (toSearchByDoctor) {
        content = (
          <Fragment>
            <p className="text-sm mb-1 font-semibold">Search Doctor</p>
            <button
              className="w-full h-10 pl-4 text-start border rounded mb-2"
              onClick={handleSearchDoctor}
            >
              {selectedDoctorBySearch?.name}
            </button>
          </Fragment>
        );
      } else {
        content = <SelectSpecialization />;
      }

    return content;
}

export default SpecializationContent